// extracted by mini-css-extract-plugin
export default {"cancel-button":"PickUpConfirmationModal_cancel-button__RJRMO","okay-button":"PickUpConfirmationModal_okay-button__9myLu"};